import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import CompactLayout from 'src/layouts/compact';

import { rootRoute } from './root';

const InsufficientRoleView = lazy(() => import('src/sections/error/insufficient-role-view'));

export const insufficientRoleRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/insufficient-role',
  component: () => (
    <CompactLayout>
      <InsufficientRoleView />
    </CompactLayout>
  ),
});